import { Fragment, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import {
  BrowserRouter,
  Route,
  Link,
  Switch,
  Redirect,
  useHistory,
} from "react-router-dom";

export default function Example(props) {
  const [show, setShow] = useState(false);
  const [pages, setListFooterPage] = useState([
    {
      link: "/",
      title: "Store",
    },
    // {
    //   link: "/About",
    //   title: "About Us",
    // },
    {
      link: "/TermsAndCondition",
      title: "Terms & Condition",
    },
    {
      link: "/RefundPolicy",
      title: "Refund Policy",
    },

    {
      link: "/Contact",
      title: "Contact",
    },
  ]);
  const history = useHistory();

  const displayColorBG = () => {
    try {
      return props.details.storeOptions.colorTheme.footer;
    } catch {
      return "white";
    }
  };

  const pageContent = () => {
    const items = [];
    pages.map((item) => {
      items.push(
        <li
          onClick={() => history.push(item.link)}
          className=" md:mr-6 cursor-pointer pt-4 lg:py-0 text-xs"
          style={{ color: displayColorBG().textColor }}
        >
          {item.title}
        </li>,
      );
    });

    return items;
  };
  return (
    <div
      className=" bg-linear-pink-invert z-50 pb-12"
      style={{ backgroundColor: displayColorBG().componentColor }}
    >
      <div className="mx-auto container pt-20 lg:pt-20  flex flex-col items-center justify-center">
        <div>
          <a href="/"></a>
        </div>
        <div className="text-black flex flex-col md:items-center f-f-l pt-3">
          <h1
            className="text-1xl  uppercase  "
            style={{ color: displayColorBG().textColor }}
          >
            {props.details.storeName}
          </h1>
          <div className="my-6 text-base text-color f-f-l">
            <ul className="md:flex items-center">
              {pageContent()}
              {/* <li  onClick={()=>history.push('/')} className=" md:mr-6 cursor-pointer pt-4 lg:py-0" style={{color:displayColorBG().textColor}}>Store</li>
                    <li onClick={()=>history.push('/PrivacyPolicy')} className="  md:mr-6 cursor-pointer pt-4 lg:py-0" style={{color:displayColorBG().textColor}}>Privacy Policy</li>
                    <li onClick={()=>history.push('/TermsAndCondition')} className="  md:mr-6 cursor-pointer pt-4 lg:py-0" style={{color:displayColorBG().textColor}}>Terms & Condition</li>
                    <li onClick={()=>history.push('/Contact')}  className=" cursor-pointer pt-4 lg:py-0">Contact</li> */}
            </ul>
          </div>
          <div className="text-xs text-center  mb-10 f-f-l">
            © 2021 {props.details.storeName} All rights reserved
            <a
              href="https://www.linkedin.com/in/michael-raffin-paculba-580761b8/"
              style={{ color: displayColorBG().textColor }}
            >
              {/* <p>Developed by: LASOPH </p>*/}
            </a>
          </div>
        </div>
        <div
          className="w-9/12  h-0.5  rounded-full"
          style={{ backgroundColor: displayColorBG().buttonColor }}
        />
      </div>
    </div>
  );
}
